import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { SalesPlants } from '../../components/plants/ui/salespalnts';
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const PlantsSalePage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Реализация</title>
            </Helmet>
            <SalesPlants/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default PlantsSalePage
